import React from 'react'
import { Button } from 'reactstrap';
import { FormTypeDiscount } from './FormTypeDiscount';
import { FormTypeDiscountDelete } from './FormTypeDiscountDelete';
import { Dialog } from 'primereact/dialog';

export const ModalCrudDiscount = (props) => {

    const { closeDialog, method, modal, name, description, percentage, active, handleInputChange, saveCreateDiscounts, saveUpdateDiscount, saveDeleteDiscount, tittleDiscount, loading
    } = props;

    return (
        <Dialog
            visible={modal}
            onHide={closeDialog}
            closable={false}
            modal
            blockScroll
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="fa fa-percent"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                Catalógo de descuentos
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v22`}
            footer={
                <>
                    {
                        method === "create" && <Button
                            color='secondary'
                            onClick={saveCreateDiscounts}
                            className={loading ? 'disabled progress-bar-animated progress-bar-striped ' : ''}
                        >
                            Crear
                        </Button>
                    }
                    {
                        method === "update" && <Button
                            color='secondary'
                            onClick={saveUpdateDiscount}
                            className={loading ? 'disabled progress-bar-animated progress-bar-striped ' : ''}
                        >
                            Actualizar
                        </Button>
                    }
                    <Button
                        color='danger'
                        onClick={closeDialog}
                        className={loading ? 'disabled progress-bar-animated progress-bar-striped ' : ''}
                    >
                        Cancelar
                    </Button>
                </>
            }
        >
            {
                (method === "create")
                    ?
                    <FormTypeDiscount
                        button="Crear"
                        {...{ closeDialog, name, description, percentage, active, handleInputChange, methodAction: saveCreateDiscounts, loading }}
                    />
                    :
                    (method === "update")
                        ?
                        <FormTypeDiscount
                            button="Actualizar"
                            {...{ closeDialog, name, description, percentage, active, handleInputChange, methodAction: saveUpdateDiscount, loading }}
                        />
                        :
                        (method === "delete")
                            ?
                            <FormTypeDiscountDelete
                                {
                                ...{
                                    closeDialog, saveDeleteDiscount, tittleDiscount, loading
                                }
                                }
                            />
                            : ""
            }
        </Dialog>
    )
}
